import * as React from 'react';
import { observer, inject } from "mobx-react";
import { Button, TextField } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';

// =====================================
// STORES
import { ICustomerStore } from '../../store/CustomerStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { ErrorMessage } from '../Layout/ErrorMessage';

@inject((allStores: any) => ({
    customerStore: allStores.store.customerStore as ICustomerStore,
}))

@observer
export default class NewCustomer extends React.Component<{ customerStore?: ICustomerStore }, any> {

    componentDidMount() {
        //this.props.customerStore.addNewLocationRow();
    }

    componentWillUnmount() {
        this.props.customerStore.reset();
    }

    render() {
        return (
            <div>
                <Header
                    title="Novi kupac"
                    isBackButtonVisible={true}
                    url="/customers" />

                <div className="container new-customer">
                    <form noValidate autoComplete="off" className="new-customer-form">
                        <TextField
                            id="customer-name"
                            label="Naziv kupca"
                            name="fullName"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.fullName}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.fullNameMessage}
                        </ErrorMessage>
                        <TextField
                            id="contact-person"
                            label="Ime i prezime kontakt osobe"
                            name="contactPerson"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.contactPerson}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.contactPersonMessage}
                        </ErrorMessage>
                        <TextField
                            id="taxId"
                            label="PIB kupca"
                            type="number"
                            name="taxId"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.taxId}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.taxIdMessage}
                        </ErrorMessage>
                        <TextField
                            id="registrationId"
                            label="MB kupca"
                            type="number"
                            name="registrationId"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.registrationId}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.registrationIdMessage}
                        </ErrorMessage>
                        <TextField
                            id="phone-number"
                            label="Kontakt telefon (06xxxxxxxx)"
                            type="number"
                            name="phoneNumber"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.phoneNumber}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.phoneNumberMessage}
                        </ErrorMessage>
                        <TextField
                            id="email"
                            label="E-mail"
                            name="email"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.email}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.emailMessage}
                        </ErrorMessage>
                        <TextField
                            id="customer-address"
                            label="Adresa kupca"
                            name="deliveryAddress"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.deliveryAddress}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.deliveryAddressMessage}
                        </ErrorMessage>
                        <TextField
                            id="customer-address"
                            label="Valuta plaćanja"
                            type="number"
                            name="paymentTerms"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.paymentTerms}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.paymentTermsMessage}
                        </ErrorMessage>
                        <TextField
                            id="address"
                            label="Adresa dostavnog mesta"
                            name="address"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.address}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.addressMessage}
                        </ErrorMessage>
                        <TextField
                            id="city"
                            label="Grad"
                            name="city"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.city}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.cityMessage}
                        </ErrorMessage>
                        <TextField
                            id="postalCode"
                            label="Poštanski broj"
                            type="number"
                            name="postalCode"
                            className="customer-form-input"
                            value={this.props.customerStore.newContractedCustomer.postalCode}
                            onChange={this.props.customerStore.onHandleChangeInput} />
                        <ErrorMessage>
                            {this.props.customerStore.postalCodeMessage}
                        </ErrorMessage>
                        {/* {this.props.customerStore.newContractedCustomer.locations.map((location, i) => {
                            let address = `address-${i}`;
                            let city = `city-${i}`;
                            let postalCode = `postalCode-${i}`;

                            return (
                                <div key={i}>
                                    <div className="col">
                                        <label>Adresa</label>
                                        <input
                                            type="text"
                                            className="form-control required"
                                            placeholder="Adresa"
                                            name="address"
                                            data-id={i}
                                            onChange={this.props.customerStore.handleChangeLocation}
                                            id={address}
                                        />
                                    </div>
                                    <div className="col">
                                        <label>Grad</label>
                                        <input
                                            type="text"
                                            className="form-control required"
                                            placeholder="Grad"
                                            name="city"
                                            data-id={i}
                                            id={city}
                                        />
                                    </div>
                                    <div className="col">
                                        <label>Postanski broj</label>
                                        <input
                                            type="text"
                                            className="form-control required"
                                            placeholder="Postanski broj"
                                            name="postalCode"
                                            data-id={i}
                                            id={postalCode}
                                        />
                                    </div>

                                    {i === 0 ? (
                                        <button
                                            onClick={this.props.customerStore.addNewLocationRow}
                                            type="button"
                                            className="btn btn-primary text-center"
                                        >
                                            <i className="fa fa-plus-circle" aria-hidden="true" />
                                        </button>
                                    ) : (
                                        <input
                                            type="button"
                                            value="-"
                                            className="btn btn-danger"
                                            onClick={() => this.props.customerStore.deteteLocationRow(i)}
                                        />
                                    )}
                                </div>
                            );
                        })} */}
                        {/* <div className="time-pickers-container">
                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                <div className="time-picker-gap">
                                    <KeyboardTimePicker
                                        label="Od"
                                        clearable={true}
                                        ampm={false}
                                        placeholder="08:00"
                                        mask="__:__ _M"
                                        value={this.props.customerStore.fromHour}
                                        onChange={date => this.props.customerStore.onHandleChangeFromDate(date)}
                                    />
                                    <ErrorMessage>
                                        {this.props.customerStore.fromHourMessage}
                                    </ErrorMessage>
                                </div>

                                <div>
                                    <KeyboardTimePicker
                                        label="Do"
                                        clearable={true}
                                        ampm={false}
                                        placeholder="16:00"
                                        mask="__:__ _M"
                                        value={this.props.customerStore.toHour}
                                        onChange={date => this.props.customerStore.onHandleChangeToDate(date)}
                                    />
                                    <ErrorMessage>
                                        {this.props.customerStore.toHourMessage}
                                    </ErrorMessage>
                                </div>

                            </MuiPickersUtilsProvider>
                        </div> */}

                        <Button
                            variant="contained"
                            color="default"
                            size="small"
                            className="btn-create-customer"
                            disabled={this.props.customerStore.isBtnSaveDisabled}
                            onClick={this.props.customerStore.saveNewContractedCustomer}
                        > Kreiraj kupca
                        </Button>
                    </form>
                </div>
            </div>
        );
    }
}